import React, { useRef, useState } from 'react';
import * as R from "ramda";
import Guid from 'guid';


import contriesList from 'iso-3166-1-alpha-2';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { AssuranceOptions, AssuranceOptionsBO, AuxiliarOptions, CommonServices, ConnectionTypes, convertConnectionTypesToServiceType, isInsurance, isSocialNetwork, OtherService, PersonalServices } from '../../../constants/utils/connectionTypes';
import { useDispatch } from 'react-redux';
import { createService } from '../../../actions/backoffice/configuration';
import { PostalCityInput } from "../../../_common/postalCityInput";

export const ServiceModal = ({ allServices, serviceType }) => {

	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const serviceModal = useRef();
	const buttonRef = useRef();
	const [selectedProfile, setSelectedProfile] = useState({ email: "", phoneNumber: "", countryCode: "" });
	const [serviceForm, setServiceForm] = useState({
		serviceType: "",
		serviceName: "",
		organizationName: "",
		addressLine1: "",
		addressLine2: "",
		addressLine3: "",
		postalCode: "",
		city: "",
		country: "FR",
		url: [{
			name: "",
			address: ""
		}]

	});

	const socialNetwork = {
		EN: "SocialNetwork",
		FR: convertConnectionTypesToServiceType("SocialNetwork")
	};

	function handleSubmit(e) {
		e.preventDefault();
		serviceModal.current.classList.add("was-validated");



		if (serviceModal.current.checkValidity()) {


			const newService = {
				id: Guid.raw(),
				type: convertConnectionTypesToServiceType(serviceForm.serviceType),
				organizationName: serviceForm.organizationName,
				name: serviceForm.serviceName,
				description: "",
				email: "",
				address: {
					streetAddress: serviceForm.addressLine1,
					streetAddress2: serviceForm.addressLine2,
					streetAddress3: serviceForm.addressLine3,
					postalCode: serviceForm.postalCode,
					addressLocality: serviceForm.city,
					addressCountry: serviceForm.country
				},
				urls: serviceForm.url.filter(u => u.address !== "")

			};

			const deathService = { ...newService, lifeEvent: 0 }
			const relocationService = { ...newService, lifeEvent: 1 }

			dispatch(createService(deathService, serviceForm.serviceType));
			// dispatch(createService(relocationService, serviceForm.serviceType));
			buttonRef.current.setAttribute("data-dismiss", "modal");
			buttonRef.current.click();
		}
		buttonRef.current.removeAttribute("data-dismiss");
	}

	function handleAddUrl() {

		setServiceForm({
			...serviceForm,
			url: [
				...serviceForm.url,
				{
					name: "",
					address: ""
				}
			]
		});
	}

	function handleDeleteUrl(index) {
		setServiceForm({
			...serviceForm,
			url: serviceForm.url.filter((u, i) => i !== index)
		});
	}


	return (
		<div className="modal fade px-0" id="serviceModal" aria-labelledby="serviceModalLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-primary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Service Assist@</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="serviceModalLabel">
									Données du services
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<p className="h5 lh-copy mb-sm">
							Consultez et modifiez ci-dessous les détails du compte <strong>Nom du service</strong> en conséquence.
						</p>
						<section className="card card-body bg-light rounded">
							<form className="form" noValidate id="useraccountForm" ref={serviceModal} onSubmit={handleSubmit}>
								<div className="form-group">
									<div className="flex-row gx-2 align-items-center mb-1">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Type"}>
											Type du service
										</label>
									</div>
									{/* <input required pattern=".*\S+.*" type="text" className="form-control rounded" id={"Type"} placeholder="Type du service" /> */}
									<select required pattern=".*\S+.*" type="text" className="form-control rounded" id={"Type"} placeholder="Type du service" onChange={(e) => setServiceForm({ ...serviceForm, serviceType: e.target.value })}>
										<option value="" className={"dropdown-item py-2 h6 mb-0 "} type="button" onChange={(e) => setServiceForm({ ...serviceForm, serviceType: e.target.value })}>
											Choisissez un type de service
										</option>
										{R.sortWith([R.ascend(R.prop("normalizedTitle"))])(allServices).map((srv, index) => {
											return (
												<option value={srv.connectionType} key={srv.connectionType + index} className={"dropdown-item py-2 h6 mb-0 "} type="button">
													{srv.title.toUpperCase()}
												</option>
											);
										})}
									</select>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="row gx-2">
									<div className="col-12 col-md-5">
										<div className="form-group">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"organizationName"}>
													Nom du service
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="La branche de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<input required pattern=".*\S+.*" type="text" className="form-control rounded" id={"organizationName"} placeholder="Nom du service" value={serviceForm.organizationName} onChange={(e) => setServiceForm({ ...serviceForm, organizationName: e.target.value })} />
											<div className="invalid-feedback">
												<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Ce champ est requis</span>
											</div>
										</div>
									</div>
									<div className="col-12 col-md-5">
										<div className="form-group">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"BranchName"}>
													Branche service
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="Le nom de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<input required pattern=".*\S+.*" type="text" className="form-control rounded" id={"BranchName"} placeholder="Branche du service" value={serviceForm.serviceName} onChange={(e) => setServiceForm({ ...serviceForm, serviceName: e.target.value })} />
											<div className="invalid-feedback">
												<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Ce champ est requis</span>
											</div>
										</div>
									</div>

									<div className="col-12 col-md-7">
										<div className="form-group">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne1"}>
													Adresse ligne 1
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<input type="text" pattern=".*\S+.*" className="form-control rounded" id={"Adresseligne1"} required placeholder="Adresse ligne 1" value={serviceForm.addressLine1} onChange={(e) => setServiceForm({ ...serviceForm, addressLine1: e.target.value })} />
											<div className="invalid-feedback">
												<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Ce champ est requis</span>
											</div>
										</div>
										<div className="form-group">
											<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2"}>
												Adresse ligne 2
											</label>
											<input type="text" className="form-control rounded" id={"Adresseligne2"} placeholder="Adresse ligne 2" value={serviceForm.addressLine2} onChange={(e) => setServiceForm({ ...serviceForm, addressLine2: e.target.value })} />
										</div>
										<div className="form-group">
											<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne3"}>
												Adresse ligne 3
											</label>
											<input type="text" className="form-control rounded" id={"Adresseligne3"} placeholder="Adresse ligne 3" value={serviceForm.addressLine3} onChange={(e) => setServiceForm({ ...serviceForm, addressLine3: e.target.value })} />
										</div>
										<div className="row g-2">
											<PostalCityInput
												postalCode={serviceForm.postalCode}
												city={serviceForm.city}
												onChange={(updatedAddress) => setServiceForm({ ...serviceForm, postalCode: updatedAddress.postalCode, city: updatedAddress.city })}
												hasWrapper={false}
												country={serviceForm.country}
												customClasses={{ city: "form-group col", postalCode: "form-group col" }}
											/>
											{/* <div className="form-group col">
												<label className="label h6 font-weight-bold my-auto" htmlFor={"Code"}>
													Code postal
												</label>

												{serviceForm.country === null || serviceForm.country === "FR" || serviceForm.country === "GF" || serviceForm.country === "PF" || serviceForm.country === "TF" ? (
													<input type="text" pattern="^(?:[0-8]\d|9[0-8])\d{3}$" className="form-control rounded" id={"Code"} placeholder="Code posta" required value={serviceForm.postalCode} onChange={(e) => setServiceForm({ ...serviceForm, postalCode: e.target.value })} />
												) : (
													<input type="text" className="form-control rounded" id={"Code"} placeholder="Code posta" required value={serviceForm.postalCode} onChange={(e) => setServiceForm({ ...serviceForm, postalCode: e.target.value })} />
												)}

												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div>
											<div className="form-group col">
												<label className="label h6 font-weight-bold my-auto" htmlFor={"Ville"}>
													Ville
												</label>
												<input type="text" pattern=".*\S+.*" className="form-control rounded" id={"Ville"} required placeholder="Ville" value={serviceForm.city} onChange={(e) => setServiceForm({ ...serviceForm, city: e.target.value })} />

												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div> */}

											<div className="form-group col-12 col-sm col-xl">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Pays"}>
													Pays
												</label>
												<select className="custom-select" id={"Pays"} tabIndex={-98} value={serviceForm.country} onChange={(e) => setServiceForm({ ...serviceForm, country: e.target.value })}>
													{Object.keys(contriesList.getData()).map((country, idx) => {
														if (country === "FR") {
															return (
																<option key={idx} value={country} selected="selected">
																	{countries.getName(country, "fr", { select: "official" })}
																</option>
															);
														} else {
															return (
																<option key={idx} value={country}>
																	{countries.getName(country, "fr", { select: "official" })}
																</option>
															);
														}
													})}
												</select>
												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* <div className="form-group">
									<label className="h6 font-weight-bolder" htmlFor="url">Url</label>
									<input type="text" className="form-control" id="url" placeholder="siteurl.fr" value={serviceForm.url} onChange={(e) => setServiceForm({ ...serviceForm, url: e.target.value })} />
									<div className={"invalid-feedback"}>
										Champs invalide
									</div>
								</div> */}
								<hr className="mb-sm" />
								<div className="form-group">
									<div className="row gx-1 gy-2">
										<div className="col-12 col-md-5">
											<label className="h6 font-weight-bolder mb-0" htmlFor="url">
												Name
											</label>
										</div>
										<div className="col-12 col-md-7">
											<label className="h6 font-weight-bolder mb-0" htmlFor="url">
												Url address
											</label>
										</div>
									</div>
									{serviceForm.url.map((url, index) => {
										return (
											<div className="input-group row gx-1 gy-2" key={index}>
												<div className="col-12 col-md-5">
													<input
														type="text"
														className="form-control rounded"
														id="url"
														placeholder="url name"
														value={serviceForm.url[index].name}
														onChange={(e) =>
															setServiceForm({
																...serviceForm,
																url: serviceForm.url.map((u, i) => {
																	if (i === index) {
																		u.name = e.target.value;
																		return u;
																	}
																	return u;
																}),
															})
														}
													/>
													<div className="invalid-feedback">
														<i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
														<span className="align-middle text-dark o-70">Ce champ est invalide</span>
													</div>
												</div>
												<div className="col-12 col-md-7">
													<div className="input-group">
														<input
															type="text"
															className="form-control rounded"
															id="url"
															placeholder="siteurl.fr"
															value={serviceForm.url[index].address}
															onChange={(e) =>
																setServiceForm({
																	...serviceForm,
																	url: serviceForm.url.map((u, i) => {
																		if (i === index) {
																			u.address = e.target.value;
																			return u;
																		}
																		return u;
																	}),
																})
															}
														/>
														<div className="invalid-feedback">
															<i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
															<span className="align-middle text-dark o-70">Ce champ est invalide</span>
														</div>
														{index !== 0 && (
															<span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded" id="basic-addon2" onClick={(e) => handleDeleteUrl(index)}>
																<i className="eva eva-trash-2-outline"></i>
															</span>
														)}
													</div>
												</div>
											</div>
										);
									})}
								</div>

								<button type="button" className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs" onClick={() => handleAddUrl()}>
									<i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
									<span className="btn-text aling-middle">Ajouter une autre url</span>
								</button>
							</form>
						</section>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal">
							Fermer
						</button>
						<button type="submit" className="btn btn-info border-none" form="useraccountForm" ref={buttonRef}>
							Enregistrer
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};